import {
  DataArray,
  DataDisplay,
  formatSchoolYear,
  Grid,
  Typography,
  useElementBreakpoints,
  useTheme,
} from "@compass/core";
import { ManageComments } from "components";
import { DataCenterFileTask as DataCenterFileTaskModel, LkDataCenterFileTaskContentId } from "generated/openApi";

export const DataCenterFileTask = (props: { task: DataCenterFileTaskModel; getTasks: () => void }) => {
  const { breakpointsRef, setBreakpoints, smallFieldBreakpoints, fullFieldBreakpoints } = useElementBreakpoints();
  const theme = useTheme();

  const showContentUpdates =
    props.task.contents &&
    props.task.contents.filter((x) => x.id === Number(LkDataCenterFileTaskContentId.Updates)).length > 0
      ? true
      : false;

  const renderTaskBasicInfo = (task: DataCenterFileTaskModel) => {
    return (
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={smallFieldBreakpoints}>
          <DataDisplay label="Name">{task.name}</DataDisplay>
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          <DataDisplay label="Status">
            <Typography
              color={task?.status?.reactColor && theme.palette[task?.status?.reactColor].main}
              fontWeight="medium"
            >
              {task?.status?.name}
            </Typography>
          </DataDisplay>
        </Grid>

        <Grid item xs={smallFieldBreakpoints}>
          <DataDisplay label="Priority">{task.priority?.name}</DataDisplay>
        </Grid>

        <Grid item xs={fullFieldBreakpoints}>
          <DataDisplay label="Data Types">
            <DataArray value={task.dataTypes?.map((x) => x.name!)} />
          </DataDisplay>
        </Grid>

        <Grid item xs={fullFieldBreakpoints}>
          <DataDisplay label="Contents">
            <DataArray value={task.contents?.map((x) => x.name!)} />
          </DataDisplay>
        </Grid>

        {showContentUpdates && (
          <Grid item xs={fullFieldBreakpoints}>
            <DataDisplay label="Content Updates">
              <DataArray value={task.contentUpdates?.map((x) => x.name!)} />
            </DataDisplay>
          </Grid>
        )}

        <Grid item xs={fullFieldBreakpoints}>
          <DataDisplay label="School Years">
            <DataArray value={task.schoolYears?.map((x) => formatSchoolYear(x.schoolYear))} />
          </DataDisplay>
        </Grid>
      </Grid>
    );
  };

  return (
    <Grid container spacing="lg">
      <Grid item xs={setBreakpoints({ xs: 12 })}>
        {renderTaskBasicInfo(props.task)}
      </Grid>

      <Grid item xs={setBreakpoints({ xs: 12 })}>
        <ManageComments comments={props.task.comments} />
      </Grid>
    </Grid>
  );
};
